/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from '@sentry/browser'

import useStatus, { State, Status } from './useStatus'

/** Call function that returns a promise and observe the state of the promise resolution. */
const usePromiseStatus = (
  fn: (...args: any[]) => Promise<unknown>,
): [
  (...args: any[]) => Promise<unknown>,
  Status,
  Record<string, unknown> | undefined,
  State,
] => {
  const { state, dispatchPending, dispatchError, dispatchSuccess } = useStatus()

  const call = (...args: any[]): Promise<unknown> => {
    dispatchPending()
    return fn(...args)
      .then((value) => {
        dispatchSuccess()
        return value
      })
      .catch((error) => {
        dispatchError(error)
        Sentry.withScope((scope) => {
          scope.setTag('issue', 'issue-mutations')
          Sentry.captureException(error)
        })
        return error
      })
  }

  return [call, state.status, state.error, state]
}

export default usePromiseStatus
